import { styled } from '@mui/material/styles';
import { GridProps as MuiGridProps } from '@mui/material/Grid';
import { MuiGrid } from '../../../../../modules/material';
import { PageLayoutProps } from './index';

export const StyledWrapper = styled('div')(({ theme }) => ({
  background: theme.palette.neutral[50],
  flexGrow: 1,
}));

export const StyledContainer = styled(MuiGrid)(({ theme }) => {
  return {
    alignItems: 'stretch',
    padding: '40px 16px 56px 16px',
    margin: '0 auto',
    maxWidth: '1280px',
    position: 'relative',

    [theme.breakpoints.up('md')]: {
      padding:
        'var(--payment-page-layout-sticky-column-padding) 20px 100px 20px',
    },
  };
});

export interface StyledColumnProps extends MuiGridProps {
  divider?: PageLayoutProps['divider'];
  noPadding?: boolean;
}

export const StyledLeftColumn = styled(MuiGrid, {
  shouldForwardProp: (prop: string) => !['divider', 'noPadding'].includes(prop),
})<StyledColumnProps>(({ theme, divider, noPadding }) => ({
  ...(divider && {
    borderBottom: `1px solid ${theme.palette.neutral[200]}`,
  }),

  [theme.breakpoints.up('md')]: {
    ...(!noPadding && {
      paddingRight: '16px',
    }),
    ...(divider && {
      borderRight: `1px solid ${theme.palette.neutral[200]}`,
      borderBottom: 'none',
    }),
  },
}));

export const StyledRightColumn = styled(MuiGrid, {
  shouldForwardProp: (prop: string) => !['noPadding'].includes(prop),
})<StyledColumnProps>(({ theme, noPadding }) => {
  return {
    ...(!noPadding && {
      [theme.breakpoints.up('md')]: {
        paddingLeft: '16px',
      },
    }),
  };
});
